<template>
  <div :class="['pagetitle', 'pagetitle-hold']">
    <div
      v-bind:class="[
        'title',
        'fs-14',
        { fixed: localFixed || propFixed },
        { noMargin: propNoMargin }
      ]"
    >
      <div class="container container-nodwapp">
        <template>
          <div v-if="!isHwrl" v-bind:class="['title-text', 'fs-14']">
            <router-link
              v-if="!baidu_toufang_shenhe"
              :to="{ path: '/index', query: { channelId: channelId } }"
              ><span class="logoContainer"><img :src="propLogo"/></span
              >{{ finalTitle }}
            </router-link>
            <div
              v-if="baidu_toufang_shenhe"
              ><span class="logoContainer"><img :src="propLogo"/></span
              >{{ finalTitle }}
            </div>
            <!-- 新增免登陆渠道联系客服提示 -->
            <div v-if="WEIBO_NOTLOGIN" @click="getKefu">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;联系客服</div>
            <v-touch
              class="pagetitle-focus"
              tag="span"
              @tap="onFocus(true)"
              v-if="SHOW_FOCUS"
              >关注领福利~</v-touch
            >
          </div>
          <!-- 临时隐藏搜索入口 2020.05.11 -->
          <div
            v-if="!HIDDEN_DETAILS && !RENMINWANG_TYPE && !baidu_toufang_shenhe && !isHpnk" 
            class="search" 
            :class="{'is-center': isHwrl}"
          >
            <v-touch @tap="goSearch" class="searchBox fs-14"
              ><input class="fakeInput" type="text" />搜索</v-touch
            >
          </div>
        </template>
      </div>
    </div>
    <!-- 关注弹窗 -->
    <myMask v-if="focusDialog"></myMask>
    <div class="box" v-if="focusDialog">
      <div class="popupimgbox">
        <div class="popupimg">
          <img
            src="../../assets/page-title-1.png"
            alt="扫描关注二维码"
            @touchstart="intouchStart"
            @touchmove="intouchMove"
            @touchend="intouchEnd"
          />
        </div>
        <!-- <p class="popuptext fs-16">
          {{ noLoginText }}长按扫码<span>&nbsp;0元领&nbsp;</span>测评
        </p> -->
        <v-touch class="closeicon" @tap="onFocus(false)"> </v-touch>
      </div>
    </div>
    <myDialog
      v-if="dialogData"
      @myDialogClose="dialogData = ''"
      :propMask="dialogData.propMask"
      :propTitle="dialogData.title"
      :propContent="dialogData.content"
      :propActions="dialogData.actions"
    >
      <div class="service-qrcode" slot="content">
        <img class="qrcode" src="../../assets/index/service-qrcode.png" alt=""/>
      </div>
    </myDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import scrollControl from '@/mixins/scrollController'
import myMask from '@/components/common/mask'
import myDialog from '@/components/common/dialog.vue'
export default {
  name: 'pageTitle',
  data() {
    return {
      localFixed: false,
      focusDialog: false,
      timeOutEvent: 0,
      dialogData: null
    }
  },
  components: {
    myMask,
    myDialog
  },
  mixins: [scrollControl],
  props: {
    propTitle: {
      required: true,
      default: '',
      type: String
    },
    propLogo: {
      required: true,
      type: String,
      default: ''
    },
    propFixed: {
      required: false,
      default: false,
      type: Boolean
    },
    propNoMargin: {
      required: false,
      default: false,
      type: Boolean
    },
    propFocus: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapState(['channelId', 'channelConfig']),
    ...mapGetters(['CHANNEL_NOT_LOGIN']),
    finalTitle() {
      return (this.propTitle == '') | (this.propTitle == undefined)
        ? ''
        : this.propTitle
    },
    isWechat() {
      return this.platform.isWechat
    },
    noLoginText() {
      let t = this.CHANNEL_NOT_LOGIN ? '复制二维码到微信，' : ''
      return t
    },
    SHOW_FOCUS() {
      //添加渠道2325详情页关闭关注按钮
      //人民网渠道关闭关注按钮
      if (!this.SHWO_VIP_TIS) {
        return false
      }
      if (
        this.channelId == 2530 ||
        this.channelId == 2535 ||
        this.channelId == 2444
      ) {
        return false
      }
      if (this.isWechat && this.CHANNEL_INTERNALCHANNEL) {
        return (
          this.channelConfig.channelType == 1 ||
          this.channelConfig.channelType == 2
        )
      } else {
        return false
      }
    },
    SHOW_DOWN_YXL() {
      //2021-1-14 不展示下载app
      return false
      //return (this.$route.name == 'testDetail' || this.$route.name == 'showIndex') && this.CHANNEL_INTERNALCHANNEL
    }
  },
  mounted() {
    // console.log(this.$route)
  },
  methods: {
    goSearch() {
      this.$router.push({
        path: '/search',
        query: {
          channelId: this.channelId
        }
      })
    },
    showFixedbBox(val) {
      this.localFixed = val
    },
    onFocus(type) {
      if (type) {
        this.$stat.send({
          name: '关注弹窗-点击打开弹窗按钮',
          properties: { 渠道名称: this.CHANNELNAME }
        })
        // 微站-测评大厅-关注领福利 神策埋点
        this.$wechatTrackEvent('weizhan_cepinghome_followgetpresent');
      } else {
        this.$stat.send({
          name: '关注弹窗-关闭打开弹窗按钮',
          properties: { 渠道名称: this.CHANNELNAME }
        })
      }
      this.focusDialog = type
    },
    //下面为监听长按事件
    intouchStart(e) {
      var this_ = this
      this_.timeOutEvent++
      this_.setTime = setTimeout(function() {
        this_.intouchStart() //长按触发事件
      }, 10)
    },
    intouchMove(e) {},
    intouchEnd(e) {
      var this_ = this
      console.log(this_.timeOutEvent)
      if (this_.timeOutEvent > 75) {
        this.$stat.send({
          name: '关注弹窗-长按关注二维码',
          properties: { 渠道名称: this.CHANNELNAME }
        })
      }
      clearInterval(this_.setTime)
      this_.timeOutEvent = 0
    },
    getKefu(){
      this.dialogData = {
        content: '答题或查看报告过程有疑问，请添加客服微信，解决您的问题。',
        actions: [
          {
            text: '好的',
            callBack: () => {
              this.dialogData = ''
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/function';
.pagetitle {
  overflow: hidden;
  height: topx(96rem);
  .icon-leaf {
    position: relative;
    width: topx(40rem);
    height: topx(40rem);
    background: url('../../assets/icon/icon_leaf.svg') no-repeat center;
    background-size: 80%;
  }

  .title {
    position: relative;
    z-index: 7;
    margin-bottom: topx(-96rem);
    height: topx(96rem);
    line-height: topx(96rem);
    color: #4c4b58;
    transition: all 0.5s;
    &.noMargin {
      margin-bottom: 0;
    }
    &.hide {
      margin-bottom: topx(-80rem);
      .container {
        transform: translate3d(0, 100%, 0);
      }
    }
    &.fixed {
      .container {
        position: fixed;
        z-index: 10;
        top: topx(3rem);
        margin-top: 0;
        transform: translate3d(0, 100%, 0);
      }
      .container-nodwapp {
        top: topx(-96rem);
      }
    }
    .container {
      transition: all 0.5s;
      box-sizing: border-box;
      width: 10rem;
      height: topx(96rem);
      padding: topx(0rem) topx(30rem);
      display: flex;
      z-index: 2;
      align-items: center;
      background: #eeeeee;
      overflow: hidden;
      margin-top: topx(100rem);
    }
    .container-nodwapp {
      margin-top: 0;
    }
    &-text {
      flex: 1 1 0;
      position: relative;
      height: topx(50rem);
      padding-left: topx(60rem);
      line-height: 1.79;
      /* font-size: topx(28rem); */
      color: #4c4b58;
      font-weight: bold;
      display: flex;
      align-items: center;
      .logoContainer {
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        width: topx(50rem);
        height: topx(50rem);
        border-radius: 50%;
        border: topx(2rem) solid #ffffff;
        @include limitLine(1);
        // overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
    .setSort {
      position: relative;
      padding-left: topx(50rem);
      .icon-leaf {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .other-search {
      position: relative;
      height: topx(56rem);
      width: 100%;
      .searchBox {
        box-sizing: border-box;
        display: inline-block;
        width: 100%;
        height: topx(56rem);
        background: #ffffff url('../../assets/icon/icon_title_search.svg')
          no-repeat topx(24rem) center;
        background-size: topx(28rem);
        border-radius: 84px;
        /* font-size: topx(28rem); */
        line-height: topx(56rem);
        text-align: left;
        color: #999999;
        padding-left: topx(56rem);
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .search {
      position: relative;
      height: topx(56rem);
      width: topx(256rem);

      &.is-center {
        width: 100%;

        .searchBox {
          width: 100%;
        }

        .fakeInput {
          width: 100%;
        }
      }

      .searchBox {
        box-sizing: border-box;
        display: inline-block;
        width: topx(256rem);
        height: topx(56rem);
        background: #d7d7d7 url('../../assets/icon/icon_title_search.svg')
          no-repeat topx(24rem) center;
        background-size: topx(28rem);
        border-radius: 84px;
        /* font-size: topx(28rem); */
        line-height: topx(56rem);
        text-align: left;
        color: #999999;
        padding-left: topx(56rem);
        position: absolute;
        left: 0;
        top: 0;
      }
      .icon-search {
        display: inline-block;
        width: topx(56rem);
        height: topx(56rem);
        background: url('../../assets/icon/icon_title_search-white.svg')
          no-repeat topx(24rem) center;
        background-size: topx(28rem);
      }
      .fakeInput {
        width: topx(200rem);
        padding-left: topx(56rem + 10);
        opacity: 0;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        color: #fff;
      }
    }
  }
  .pagetitle-focus {
    display: inline-block;
    color: #fff;
    width: topx(153rem);
    border-radius: topx(8rem);
    text-align: center;
    margin-left: topx(15rem);
    position: relative;
    height: topx(40rem);
    line-height: topx(40rem);
    font-size: topx(22rem);
    background: url('../../assets/show/indexTitle/indexTitle_btn.png') no-repeat center;
    background-size: 100% 100%;
    animation: scale-keyframes 0.75s infinite;
    text-align: center;
    margin-right: topx(15rem);
  }
  .box {
    position: fixed;
    width: 100%;
    height: 100%;
    left: inherit;
    top: 0;
    z-index: 11;
    justify-content: center;
    display: flex;
    display: -webkit-flex;

    .popupimgbox {
      width: topx(400rem);
      height: topx(400rem);
      margin-top: topx(209rem);
      // position: fixed;
      z-index: 11;
      background: #fff;
      box-shadow: 0 20px 50px 0 rgba(2, 126, 250, 0.1);
      border-radius: topx(26rem);
      position: relative;
      .popupimg {
        width: topx(310rem);
        height: topx(310rem);
        margin: topx(45rem);
        img {
          width: 100%;
          height: 100%;
        }
      }
      // .popuptext {
      //   margin: topx(30rem) 0 topx(60rem) 0;
      //   height: topx(32rem);
      //   color: #666666;
      //   line-height: 0.42667rem;
      //   width: 100%;
      //   text-align: center;
      //   span {
      //     color: #ffa800;
      //   }
      // }
      .closeicon {
        height: topx(44rem);
        line-height: topx(44rem);
        width: topx(44rem);
        background: url('../../assets/btn_close.png') no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        bottom: topx(-74rem);
        margin-left: topx(-22rem);
        left: 50%;
      }
    }
  }
  .page-yxl-box {
    width: topx(750rem);
    height: topx(100rem);
    background: #f2f9fe;
    position: relative;
    background: url('../../assets/show/indexTitle/indexTitle_yxl_bg.png')
      no-repeat center;
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
    .yxl-btn {
      width: topx(204rem);
      height: topx(53rem);
      position: absolute;
      top: topx(24rem);
      right: topx(25rem);
      background: url('../../assets/show/indexTitle/indexTitle_btn.png')
        no-repeat center;
      background-size: 100% 100%;
    }
    .btn--shake {
      animation: scale-keyframes 0.75s infinite;
    }

    @keyframes scale-keyframes {
      0% {
        -webkit-transform: scale(1);
        transform: scale(1);
      }

      50% {
        -webkit-transform: scale(0.93);
        transform: scale(0.93);
      }

      to {
        -webkit-transform: scale(1);
        transform: scale(1);
      }
    }
  }

  .service-qrcode {
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: topx(40rem);
    img {
      width: topx(500rem);
      height: topx(492rem);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/pageTitle.vue